<ng-container [formGroup]="form">
	<mat-form-field>
		<input
			autocomplete="first-name"
			maxlength="50"
			matInput
			required
			placeholder="First Name"
			formControlName="firstName"
		/>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="last-name"
			matInput
			maxlength="50"
			required
			placeholder="Last Name"
			formControlName="lastName"
		/>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="employee-code"
			matInput
			maxlength="10"
			placeholder="Employee code"
			formControlName="employeeCode"
		/>
		<mat-error *ngIf="form.get('employeeCode').hasError('notUnique')"
			>This employee code is already in use.</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<input 
			required 
			matInput
			maxlength="50" 
			placeholder="Paycom Id" 
			formControlName="paycomId" 
		/>
		<mat-error *ngIf="form.get('paycomId').hasError('notUnique')"
			>This paycom ID is already in use.</mat-error
		>
		<mat-error *ngIf="form.get('paycomId').hasError('required')"
			>Required</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="job-title"
			matInput
			maxlength="50"
			placeholder="Job Title"
			formControlName="jobTitle"
		/>
	</mat-form-field>
	<mat-form-field *ngIf="canViewHourlyRate">
		<rpshared-currency-input
			autocomplete="regular-hourly-rate"
			required
			placeholder="Regular Hourly Rate"
			formControlName="regularHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('regularHourlyRate').hasError('required')"
			>Required</mat-error
		>
		<mat-error
			*ngIf="form.get('regularHourlyRate').hasError('isNotNumeric')"
			>Not a valid value</mat-error
		>
		<mat-error *ngIf="form.get('regularHourlyRate').hasError('min')"
			>Value must be above $0.00</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			(selectionChange)="selectFieldWorkerType($event.value)"
			formControlName="type"
			[compareWith]="idComparer"
			disableOptionCentering="true"
			required
			placeholder="Field Worker Type"
		>
			<mat-option
				*ngFor="let type of fieldWorkerTypes$ | async"
				[value]="type"
			>
				{{ displayDescription(type) }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			formControlName="status"
			[compareWith]="idComparer"
			disableOptionCentering="true"
			placeholder="Field Worker Status"
		>
			<mat-option
				*ngFor="let status of employeeStatuses$ | async"
				[value]="status"
			>
				{{ displayDescription(status) }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			(selectionChange)="selectPayrollType.next($event.value)"
			formControlName="payrollType"
			disableOptionCentering="true"
			required
			placeholder="Payroll Type"
		>
			<mat-option *ngFor="let type of payrollTypes" [value]="type">
				{{ displayPayrollType[type] }}
			</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			formControlName="perDiemAgreementType"
			disableOptionCentering="true"
			placeholder="Per Diem Agreement Type"
		>
			<mat-option
				*ngFor="let perDiemType of perDiemAgreementTypes"
				[value]="perDiemType"
			>
				{{ displayAgreementType[perDiemType] }}
			</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="city-lived-in"
			matInput
			maxlength="256"
			placeholder="City Lived In"
			formControlName="cityLivedIn"
		/>
	</mat-form-field>
	<mat-form-field *ngIf="worksInTheField">
		<input
			autocomplete="state-lived-in"
			matInput
			maxlength="2"
			placeholder="State Lived In"
			required
			formControlName="statedLivedIn"
			[matAutocomplete]="statedLivedIn"
		/>
		<mat-autocomplete #statedLivedIn="matAutocomplete">
			<mat-option
				*ngFor="let state of filteredStatesLivedIn$ | async"
				[value]="state"
			>
				{{ state }}
			</mat-option>
		</mat-autocomplete>
		<mat-error *ngIf="form.get('statedLivedIn').hasError('invalidItem')"
			>Must be a valid 2-letter state.</mat-error
		>
		<mat-error *ngIf="form.get('statedLivedIn').hasError('required')"
			>Required</mat-error
		>
	</mat-form-field>
	<mat-form-field *ngIf="worksInTheField">
		<mat-select
			placeholder="Field Team"
			disableOptionCentering="true"
			[compareWith]="idComparer"
			formControlName="team"
			required
		>
			<mat-option *ngFor="let team of fieldTeams$ | async" [value]="team">
				{{ displayFieldTeam(team) }}
			</mat-option>
		</mat-select>
		<mat-error *ngIf="form.get('team').hasError('required')">
			Field is required
		</mat-error>
	</mat-form-field>
	<mat-slide-toggle
		formControlName="isExcludedFromPayroll"
		labelPosition="before"
		class="custom-slider"
		>Is Excluded From Payroll
	</mat-slide-toggle>
</ng-container>
